import React from 'react';
import '../catering-style/catering-style.css';

const BannerTotal: React.FC = () => {
    return (
        <header className="bannertotal">
            <h2>Cotizaciones</h2>
            <p>Cotiza con nosotros tu evento</p>
        </header>
    );
};

export default BannerTotal;
